module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABJElEQVRIS+2WMU7DMBSG3x8WJ0s7cAAOgERuAEew0gNAx5qlPQHcgC4kY3sBDJyAcAQGjoFUJrdVlYdcVBGhRLKoyVJ7tOT/s//3P9ugjgf24cnCnJAQi6chFq46fwZm+XIM8J0FMdFQj+K5C3QPoCkBOv+G8PPDKJGdAZnpVav4IgCtA15qGCythylY2tpaWf7T+CE0ITQudzAdRmjIvoe8fQ/ftEpSF2ucbhp5v04jbF4A9JtEmflDq+TYGzArzC2IbtoEmflTq6RxM7/XOJ1wkK8koXrsDGhBWWGuQDRrsdTvCXcQW8ujaFMSoVcHe69hXVzOuB8tTQnC2W6eK3rX1/Gpt9A0CQ1yMyfQ5bYpGBOtxPRfgVbcholRpZUQU9ff9xeAwsUdtEwHYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/editSourceIcon/down-hv.png
// module id = eEgk
// module chunks = 96